import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import CommonOrderComponent from "~/components/parking/Checkout/CommonOrderComponent"
import { PAYMENT_PROVIDERS } from "~/utilities/constants"


@inject(all => ({
  totalSelectedPayableAmount: all.store.parkingFlow.results.totalSelectedPayableAmount,
  feeForSelectedPayable: all.store.parkingFlow.results.feeForSelectedPayable,
  totalServiceFee: all.store.parkingFlow.results.totalServiceFee,
  paySubtotal: all.store.parkingFlow.results.paySubtotal,
  userCredits: all.store.auth.user.credits,
  paymentProcessor: all.store.payment.paymentProcessor,
}))

@observer
class OrderCard extends Component {

  render() {
    const {
      userCredits,
      totalSelectedPayableAmount,
      totalServiceFee,
      feeForSelectedPayable,
      paySubtotal,
      paymentProcessor,
    } = this.props
    let finalPaySubTotal = paySubtotal
    let finalUserCredits = userCredits
    if (paymentProcessor === PAYMENT_PROVIDERS.evervault && userCredits > 0) {
      finalPaySubTotal -=  Math.min(totalServiceFee, userCredits) - userCredits
      finalUserCredits = Math.min(totalServiceFee, userCredits)
    }
    return (
      <>
        {paymentProcessor === PAYMENT_PROVIDERS.evervault ? (
          <CommonOrderComponent
            payableAmount={totalSelectedPayableAmount}
            serviceFee={feeForSelectedPayable}
            processingFee={totalServiceFee}
            userCredits={finalUserCredits}
            paySubTotal={finalPaySubTotal}
            paymentProcessor={paymentProcessor}
          />
        ) : (
          <CommonOrderComponent
            payableAmount={totalSelectedPayableAmount}
            serviceFee={totalServiceFee}
            processingFee={feeForSelectedPayable}
            userCredits={userCredits}
            paySubTotal={finalPaySubTotal}
            paymentProcessor={paymentProcessor}
          />
        )}
      </>
    )
  }
}

export default OrderCard
